import { render, staticRenderFns } from "./FeedAlertResources.vue?vue&type=template&id=389c1f0c"
import script from "./FeedAlertResources.vue?vue&type=script&lang=js"
export * from "./FeedAlertResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports